module.exports = __webpack_public_path__ + "img/contribution.6f8359f1.png";